import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\GetCompanyActivitiesByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyActivitiesByIdController.php
* @route '/api/company/{company}/activities'
*/
const GetCompanyActivitiesByIdController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyActivitiesByIdController.url(args, options),
    method: 'get',
})

GetCompanyActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Company\GetCompanyActivitiesByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyActivitiesByIdController.php
* @route '/api/company/{company}/activities'
*/
GetCompanyActivitiesByIdController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return GetCompanyActivitiesByIdController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\GetCompanyActivitiesByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyActivitiesByIdController.php
* @route '/api/company/{company}/activities'
*/
GetCompanyActivitiesByIdController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCompanyActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Company\GetCompanyActivitiesByIdController::__invoke
* @see app/Http/Controllers/Company/GetCompanyActivitiesByIdController.php
* @route '/api/company/{company}/activities'
*/
GetCompanyActivitiesByIdController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCompanyActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetCompanyActivitiesByIdController